/**
 * Enum đã lập hóa đơn
 * HQMINH 02.08.2022
 */
export default {
  /**
   * Tất cả
   */
  All: -1,

  /**
   * Chưa lập hóa đơn
   */
  NotInvoiced: 0,

  /**
   * Đã lập hóa đơn
   */
  Invoiced: 1,
};
